(() => {
  if (window.dfHeaderHover) return;
  window.dfHeaderHover = true;

  const CLOSE_DELAY = 150;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  const bind = () => {
    const menus = document.querySelectorAll('.header__inline-menu header-menu');

    menus.forEach((menu) => {
      if (menu.dataset.dfHover) return;
      menu.dataset.dfHover = 'true';

      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!summary) return;
      let closeTimer;

      menu.addEventListener('pointerenter', () => {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu header-menu').forEach((other) => {
          if (other !== menu) other.close();
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });

      // The short delay stops the menu closing while the pointer crosses the gap to the submenu.
      menu.addEventListener('pointerleave', () => {
        if (!canHover.matches) return;
        closeTimer = setTimeout(() => menu.close(), CLOSE_DELAY);
      });

      // A mouse click opens the category page. Keyboard activation (detail 0) still toggles the menu.
      summary.addEventListener('click', (event) => {
        if (!canHover.matches || event.detail === 0 || !summary.dataset.dfUrl) return;
        event.preventDefault();
        window.location.href = summary.dataset.dfUrl;
      });
    });
  };

  bind();
  document.addEventListener('shopify:section:load', bind);
})();
